
const getOpenTranscriptsModalDocProps = () => {
    return {
        adminOnly: false,
        bankEditable: false,
        category: "business_financial_and_underwriting",
        comment: null,
        confirmed: false,
        creditDoc: false,
        custom: false,
        deletable: false,
        description: null,
        displayCommentable: true,
        documentKey: null,
        editable: false,
        esignReminderSentAt: null,
        esignStatus: null,
        esignable: false,
        esigned: false,
        fileUrls: [],
        filenames: [],
        files: [],
        hasUploadNotifications: null,
        headerImageUrl: null,
        helloSignRoles: [
            {
                label: "Authorized Signer",
                rid: "7890123",
                value: "signer_1"
            }
        ],
        esignSigners: [],
        helloSignTemplateId: "abcedf12345",
        id: "123456778",
        instructions: "Please scroll down and electronically sign the form",
        live: true,
        phase: "main",
        reference_files: "[]",
        rid: 123,
        signatureRequests: [],
        skippable: true,
        skipped: false,
        status: 'pending_review',
        title: '4506T Request',
        type: 'Document::T4506t',
        uploaded: false,
    }
}

export default getOpenTranscriptsModalDocProps;